<script setup lang="ts">
import type { BreadcrumbItem, BreadcrumbProps } from '@nuxt/ui'
import { nuxtUiMerge } from '~/utils/tw-utils'

interface VBreadcrumbProps {
  items: BreadcrumbItem[]
  separatorIcon?: string
  ui?: BreadcrumbProps['ui']
}

const props = withDefaults(defineProps<VBreadcrumbProps>(), {
  separatorIcon: 'fa6-solid:chevron-right'
})

const { t, te } = useI18n()

const computedUI = computed<BreadcrumbProps['ui']>(() =>
  nuxtUiMerge(props.ui, {
    list: tw`block md:flex`,
    link: tw`no-underline max-md:my-1 text-default aria-[current="page"]:text-primary dark:text-white dark:aria-[current="page"]:text-success`,
    separator: tw`hidden md:flex`
  })
)

const breadcrumbItems = computed<BreadcrumbItem[]>(() => {
  const trailingItems = props.items.map((item) => ({
    ...item,
    to:
      typeof item.to === 'string'
        ? item.to.startsWith('/')
          ? item.to
          : `/${item.to}`
        : item.to,
    label: item.label && te(item.label) ? t(item.label) : item.label,
    icon: 'fa6-solid:map-pin'
  }))

  const lastItem = trailingItems.at(-1)
  if (lastItem) {
    lastItem.active = true
  }

  return [
    {
      to: '/',
      label: t('links.thuisgekookt'),
      icon: 'fa6-solid:house'
    },
    ...trailingItems
  ]
})
</script>

<template>
  <section class="section">
    <UBreadcrumb :items="breadcrumbItems" :ui="computedUI" :separator-icon />
  </section>
</template>

<style scoped></style>
